import React from 'react';
import Notifs from 'constant/notification-settings';
import useStyles from './styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from 'components/common/Button';
import useSnack from 'hooks/useSnack';
import { useMutation, useQuery } from '@apollo/react-hooks';
import {
  GET_NOTIFICATIONS_SETTINGS,
  UPDATE_NOTIFICATIONS_SETTINGS,
} from 'graphql/notification';
import { Box, FormControlLabel, InputLabel } from '@material-ui/core';
import { Formik, Form, Field } from 'formik';
import { Switch } from 'formik-material-ui';
import { uniqBy } from 'lodash';
import { useSelector } from 'react-redux';

const NotificationsSettings = ({ user, editable = true }) => {
  const classes = useStyles();
  const snack = useSnack();
  const [initialState, setinitialState] = React.useState({
    'emailCommunication': true,
    'emailEssays': true,
    'emailGeneral': true,
    'emailMeetings': true,
    'emailSchool list': true,
    'emailTimeline': true,
    'smsEssays': true,
    'smsGeneral': true,
    'smsMeetings': true,
    'smsSchool list': true,
    'smsTimeline': true,
  });
  const { data, loading } = useQuery(GET_NOTIFICATIONS_SETTINGS, {
    variables: { userId: user.id },
    fetchPolicy: 'network-only',
  });
  const [update] = useMutation(UPDATE_NOTIFICATIONS_SETTINGS);
  const profile = useSelector((s) => s.student.profile);
  const isSolo = profile?.product_type === 'solo';
  const isCohort = profile?.product_type === 'cohort';

  React.useEffect(() => {
    if (data) {
      setinitialState({
        'emailCommunication': data.settings.find((f) => f.topic === 'SMS_SENT')
          ?.email,
        'emailEssays': data.settings.find((f) => f.topic === 'ESSAY_CREATE')
          ?.email,
        'emailGeneral': data.settings.find(
          (f) => f.topic === 'STUDENT_INACTIVE',
        )?.email,
        'emailMeetings': data.settings.find(
          (f) => f.topic === 'COACHING_SCHEDULED',
        )?.email,
        'emailSchool list': data.settings.find(
          (f) => f.topic === 'SCHOOL_STATUS_UPDATE',
        )?.email,
        'emailTimeline': data.settings.find(
          (f) => f.topic === 'EXERCISE_SUBMITTED',
        )?.email,
        'smsEssays': data.settings.find((f) => f.topic === 'ESSAY_CREATE')?.sms,
        'smsGeneral': data.settings.find((f) => f.topic === 'STUDENT_INACTIVE')
          ?.sms,
        'smsMeetings': data.settings.find(
          (f) => f.topic === 'COACHING_SCHEDULED',
        )?.sms,
        'smsSchool list': data.settings.find(
          (f) => f.topic === 'SCHOOL_STATUS_UPDATE',
        )?.sms,
        'smsTimeline': data.settings.find(
          (f) => f.topic === 'EXERCISE_SUBMITTED',
        )?.sms,
      });
    }
  }, [data]);

  const toggleValidation = (vals) => {
    return (
      (vals.emailCommunication || vals.smsCommunication) &&
      (vals.emailEssays || vals.smsEssays) &&
      (vals.emailGeneral || vals.smsGeneral) &&
      (vals.emailMeetings || vals.smsMeetings) &&
      (vals.emailTimeline || vals.smsTimeline) &&
      (vals['emailSchool list'] || vals['smsSchool list'])
    );
  };

  const setNotifsSettings = async (vals) => {
    const isValid = toggleValidation(vals);
    if (!isValid && user.type !== 'admin') {
      snack.info(`Please opt for atleast one. Both can't be disabled.`);
      return;
    }
    const notifDataEmail = [];
    const notifDataSMS = [];
    const objectArray = Object.entries(vals);
    objectArray.forEach(([key, value]) => {
      if (key.startsWith('email')) {
        const k = key.split('email')[1];
        const getEmailConfig = Notifs.filter((f) => f.name === k);

        getEmailConfig[0][k].map((m, i) =>
          notifDataEmail.push({
            user_id: user.id,
            topic: m.value,
            email: value,
          }),
        );
      } else if (key.startsWith('sms')) {
        const s = key.split('sms')[1];
        const getSmsConfig = Notifs.filter((f) => f.name === s);

        getSmsConfig[0][s].map((m, i) =>
          notifDataSMS.push({
            user_id: user.id,
            topic: m.value,
            sms: value,
          }),
        );
      }
    });
    const merged = [
      ...notifDataEmail
        .concat(notifDataSMS)
        .reduce(
          (m, o) => m.set(o.topic, Object.assign(m.get(o.topic) || {}, o)),
          new Map(),
        )
        .values(),
    ];
    await update({
      variables: {
        data: merged,
      },
    })
      .then(() => snack.success('Settings Updated'))
      .catch((e) => snack.error(e.message));
  };

  return (
    <Card className={classes.card}>
      <CardContent>
        <Formik
          initialValues={initialState}
          enableReinitialize
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              setSubmitting(false);
              setNotifsSettings(values);
            }, 500);
          }}
        >
          {({ submitForm, isSubmitting, errors }) => (
            <Form>
              {Notifs.map((op, i) => {
                return (
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="baseline"
                    paddingTop={1}
                  >
                    <Box>
                      <Typography variant="subtitle2">
                        {(((isSolo || isCohort) && op.name === 'Essays') || !isSolo || !isCohort) &&
                          !op.exclude.includes(user.type) &&
                          op.name}
                      </Typography>
                      {uniqBy(op[op.name], (x) => x.label).map((m) => {
                        if (
                          (((isSolo || isCohort) && op.name === 'Essays') || !isSolo || !isCohort) &&
                          m.actors.includes(user.type)
                        )
                          return (
                            <InputLabel style={{ flex: 1, padding: 10 }}>
                              {m.label}
                            </InputLabel>
                          );
                      })}
                    </Box>
                    {(((isSolo || isCohort) && op.name === 'Essays') || !isSolo || !isCohort) &&
                      !op.exclude.includes(user.type) && (
                        <Box>
                          <FormControlLabel
                            control={
                              <Field
                                size="small"
                                component={Switch}
                                type="checkbox"
                                name={`email${op.name}`}
                              />
                            }
                            label="Email"
                          />
                          {
                            <FormControlLabel
                              control={
                                <Field
                                  size="small"
                                  component={Switch}
                                  type="checkbox"
                                  name={`sms${op.name}`}
                                />
                              }
                              label="Text"
                            />
                          }
                        </Box>
                      )}
                  </Box>
                );
              })}
              <br />

              <Divider />
              <Box display="flex" marginTop={4}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                  onClick={submitForm}
                  disabled={!editable}
                >
                  {'Save'}
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </CardContent>
    </Card>
  );
};

export default NotificationsSettings;
